import React from 'react'
import { Field } from 'redux-form'
import Form from 'components/form/Form'
import Heading from 'components/Heading'
import CustomSelectField from 'components/form/CustomSelectField'
import CurrencySingleValue from 'components/form/CurrencySingleValue'
import CurrencyOption from 'components/form/CurrencyOption'
import Flag from 'components/Flag'
import ChartTabs from 'components/ChartTabs'
import {Link} from 'react-router-dom'
import CurrencyDetails from './CurrencyDetails'
import CryptoCurrencyDetails from './CryptoCurrencyDetails'

export const MobileCurrencyList = ({currencies, selectedCurrencyRate, mode, ...props}) => {
	return <div className='o-layout'>
		<div className='o-layout__item u-1/2'>
			<Heading
				text='Валутни курсове'
				classes='u-heading-line u-heading-line-cornflower'
			/>
		</div>
		<div className='o-layout__item u-1/2 o-layout--right'>
			<Form >
				<Field
					className='c-select--dark'
					name='currency'
					placeholder='Избери'
					component={CustomSelectField}
					optionComponent={CurrencyOption}
					SingleValue={ props => <CurrencySingleValue position='left' {...props}/>}
					options={currencies.map(c => ({
						value: c.id,
						name: c.name,
						abbreviature: c.abbreviature,
						flag: c.flag,
						isCrypto: c.is_crypto
					}))}
				/>
			</Form>
		</div>
		{
			selectedCurrencyRate
				? <div className='o-layout__item u-1/1'>
					<div className='u-margin-vertical u-center-on-mobile'>
						<Flag className='u-margin-right-small' isCrypto={ mode === 'crypto' } src={selectedCurrencyRate.flag} alt={selectedCurrencyRate.name}  />
						<p className='u-margin-none'><span className='u-weight--semi-bold'>{ selectedCurrencyRate.abbreviature }</span> - { selectedCurrencyRate.name }</p>
						{
							mode === 'monetary'
								? <CurrencyDetails currencyRate={selectedCurrencyRate} />
								: <CryptoCurrencyDetails currencyRate={selectedCurrencyRate} />
						}
						<p><Link to={`/${mode === 'monetary' ? 'currencies' : 'cryptocurrencies'}/rates/${selectedCurrencyRate.abbreviature}`} className='u-text--cornflower u-underline'>Виж</Link></p>
					</div>
					<ChartTabs currency={mode === 'monetary'
						? selectedCurrencyRate.to_currency_id
						: selectedCurrencyRate.to_crypto_currency_id
					} mode={mode} {...props} />
				</div>
				: <div className='o-layout__item u-1/1'><p>Моля изберете валута от падащото меню</p></div>
		}
	</div>
}

export default MobileCurrencyList
